import Image from 'next/image';

export const SectionListItem = ({
  slug,
  title,
}: {
  slug: string | null;
  title: string;
}) => {
  return (
    <div className=" cursor-pointer">
      <div className="rounded-lg overflow-hidden transition-all hover:shadow-lg hover:border-primary/50">
        <div className="aspect-[3/4] relative bg-muted">
          <Image
            src={`https://pub-62bdcba1fb1c45dba040477de5e97921.r2.dev/${slug}.jpg`}
            fill
            sizes="100vw"
            alt={title}
            className="object-cover"
            placeholder="blur"
            loading="lazy"
          />
        </div>
        <div className="p-4">
          <p className="text-sm font-medium text-foreground line-clamp-2">
            {title}
          </p>
        </div>
      </div>
    </div>
  );
};
